import ImageUploader from '../bundles/components/ImageUploader/ImageUploader.tsx';
import ErrorPage from '../bundles/components/ErrorPage/ErrorPage.tsx';
import CollaboratorsPage from '../bundles/apps/CompaniesPageApp/pages/CollaboratorsPage/CollaboratorsPage.tsx';
import MyCompaniesPage from '../bundles/apps/ProfileApp/pages/MyCompaniesPage/MyCompaniesPage.tsx';
import ProfileSubmenu from '../bundles/apps/ProfileApp/components/ProfileSubmenu/ProfileSubmenu.tsx';
import MembershipPage from '../bundles/apps/ProfileApp/pages/MembershipPage/MembershipPage.tsx';
import AccountPage from '../bundles/apps/ProfileApp/pages/AccountPage/AccountPage.tsx';
import SecondaryMarketApp from '../bundles/apps/SecondaryMarket/SecondaryMarketApp.tsx';
import ForumApp from '../bundles/otherApps/ForumApp/ForumApp.tsx';
import TextEditor from '../bundles/apps/CompaniesPageApp/components/TextEditor/TextEditor.tsx';
import BFApp from '../bundles/BFApp.tsx';
import MessageApp from '../bundles/apps/MessageApp/MessageApp';
import Confirmation from '../bundles/components/Confirmation/Confirmation.tsx';
import AcceptAndConfirmListApp from '../bundles/otherApps/AcceptAndConfirmListApp/AcceptAndConfirmListApp.tsx';
import InvestmentAgreementApp from '../bundles/otherApps/InvestmentAgreementApp/InvestmentAgreementApp.tsx';
import CelsiusQuizApp from '../bundles/otherApps/CelsiusQuizApp/CelsiusQuizApp.tsx';
import TermsAndConditionsApp from '../bundles/otherApps/TermsAndConditionsApp/index.tsx';
import FooterApp from '../bundles/otherApps/FooterApp/FooterApp.tsx';
import MenuApp from '../bundles/otherApps/MenuApp/MenuApp.tsx';
import MarketsApp from '../bundles/apps/MarketsApp';


const reactOnRails = typeof window === 'undefined' ? require('react-on-rails').default : (window.ReactOnRails || require('react-on-rails').default);


reactOnRails.register({
  ImageUploader,
  CollaboratorsPage,
  ErrorPage,
  ProfileSubmenu,
  MyCompaniesPage,
  MembershipPage,
  AccountPage,
  SecondaryMarketApp,
  TextEditor,
  ForumApp,
  BFApp,
  MessageApp,
  Confirmation,
  AcceptAndConfirmListApp,
  InvestmentAgreementApp,
  CelsiusQuizApp,
  TermsAndConditionsApp,
  FooterApp,
  MenuApp,
  MarketsApp
});
